import { COMMON_PERMISSIONS } from '@/commons/permissoesGrupos';

export default [
    // Lista de Grupos
    {
        path: '/grupos',
        name: 'listaGrupos',
        component: () => import('@/modules/basicos/views/ListaGrupoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Areas de Atuação
    {
        path: '/areasatuacao',
        name: 'listaAreasAtuacao',
        component: () => import('@/modules/basicos/views/ListaAreaAtuacaoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,

        },
    },
    // Lista de Bancos
    {
        path: '/bancos',
        name: 'listaBancos',
        component: () => import('@/modules/basicos/views/ListaBancoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES,
        },
    },
    // Lista de Escolaridades
    {
        path: '/escolaridades',
        name: 'listaEscolaridades',
        component: () => import('@/modules/basicos/views/ListaEscolaridadeView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Tipos de Instrumentos Jurídicos
    {
        path: '/tiposinstrumentosjuridicos',
        name: 'listaTipoInstrumentoJuridico',
        component: () => import('@/modules/basicos/views/ListaTipoInstrumentoJuridicoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Tipos de Cargos
    {
        path: '/tiposcargos',
        name: 'listaTipoCargo',
        component: () => import('@/modules/basicos/views/ListaTipoCargosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES,
        },
    },
    {
        path: '/tipossolicitacoes',
        name: 'listaTipoSolicitacao',
        component: () => import('@/modules/basicos/views/ListaTipoSolicitacaoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Tipos de Solicitação Administrativa
    {
        path: '/tipossolicitacoesadministrativas',
        name: 'listaTipoSolicitacaoAdministrativa',
        component: () => import('@/modules/basicos/views/ListaTipoSolicitacaoAdministrativaView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY },
    },
    // Lista de Categorias de Veículos
    {
        path: '/categoriasveiculos',
        name: 'listaCategoriasVeiculos',
        component: () => import('@/modules/basicos/views/ListaCategoriasVeiculosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES,
        },
    },
    // Lista de Tipos de Aplicação Financeira
    {
        path: '/tiposaplicacaofinanceira',
        name: 'listaTipoAplicacaoFinanceira',
        component: () => import('@/modules/basicos/views/ListaTipoAplicacaoFinanceiraView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Tipo de Status de Projetos
    {
        path: '/statusprojetos',
        name: 'listaTiposStatusProjetos',
        component: () => import('@/modules/basicos/views/ListaTipoStatusProjetoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Projeto Labels
    {
        path: '/projetolabel',
        name: 'listaProjetoLabels',
        component: () => import('@/modules/basicos/views/ListaProjetoLabelView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Rubricas Financeiras
    {
        path: '/rubricasfinanceiras',
        name: 'listaRubricasFinanceiras',
        component: () => import('@/modules/basicos/views/ListaRubricaFinanceiraView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Permissões
    {
        path: '/permissoes',
        name: 'listaPermissoes',
        component: () => import('@/modules/basicos/views/ListaPermissaoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY,
        },
    },
    // Lista de Tipos de Benefícios
    {
        path: '/beneficios',
        name: 'listaBeneficios',
        component: () => import('@/modules/basicos/views/ListaBeneficiosView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY },
    },
    // Lista de Tipos de Processo
    {
        path: '/tiposprocessos',
        name: 'listaTiposProcessos',
        component: () => import('@/modules/basicos/views/ListaTipoProcessoView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES },
    },
    // Cadastro de Tipo de Processo
    {
        path: '/tiposprocessos/novo',
        name: 'cadastroTipoProcesso',
        component: () => import('@/modules/basicos/views/cadastros/CadastroTipoProcessoView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES },
    },
    // Edição de Tipo de Processo
    {
        path: '/tiposprocessos/:id/editar',
        name: 'editarTipoProcesso',
        component: () => import('@/modules/basicos/views/cadastros/CadastroTipoProcessoView.vue'),
        props: true,
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES },
    },
    // Lista de Tipos de Folha CLT
    {
        path: '/tiposfolhaclt',
        name: 'listaTipoFolhaClt',
        component: () => import('@/modules/basicos/views/ListaTipoFolhaCltView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY },
    },
    // Lista de Tipos de Rescisão CLT
    {
        path: '/tiposrescisaoclt',
        name: 'listaTipoRescisaoClt',
        component: () => import('@/modules/basicos/views/ListaTipoRescisaoCltView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.ADMIN_ONLY },
    },
    // Lista de IPs Autorizados
    {
        path: '/ipspermitidos',
        name: 'listaIpsPermitidos',
        component: () => import('@/modules/basicos/views/ListaIpsPermitidosView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.ADMINISTRADORES },
    },
]